<section class="w-full">
    <div class="flex flex-col justify-center my-10 max-sm:my-16 px-4 flex-shrink-0">
        

        <div class=" w-full">
            <div class="flex flex-row pb-4 hover:cursor-pointer" routerLink="/dashboard">
              <div class="mr-2">
                <mat-icon svgIcon="heroicons_solid:arrow-left-circle" [color]="'primary'"></mat-icon>
              </div>
              <div class="font-bold">
                Go back to dashboard
              </div>
            </div>
            <div>
              <div class="text-primary text-4xl font-extrabold">
                <h1>
                    Balances
                </h1>
              </div>
            </div>
            <hr class="my-5">
        </div>

        <div class="bg-primary-400 text-white p-4 rounded-xl">
            <div *ngIf="accountInArrears">
                <h2 class="text-2xl pb-2">
                    Your account is in arrears.
                </h2>
                <p>Please review the outstanding amount and make payment through the facility provided below to avoid suspension of your service.</p>
            </div>
            <div *ngIf="!accountInArrears">
                <h2 class="text-2xl pb-2">
                    Your account is in order.
                </h2>
                <p>If you would like to pay your account in advance, please do so below.</p>
            </div>
        </div>

        <div class="my-4">
            <fuse-card class="flex flex-col p-4">
                <div class="flex justify-between">
                    <div>
                        <p class="font-extrabold text-black pb-3">Description</p>
                        <p *ngIf="accountInArrears" class="text-black">Outstanding balance</p>
                        <p *ngIf="!accountInArrears" class="text-black">Payment in advance</p>
                    </div>
                    <div>
                        <p class="font-extrabold text-black pb-3">Balance</p>
                        <p class="font-extrabold text-primary">{{customerBalance | currency : 'R' }}</p>
                    </div>
                </div>

                <hr class="my-3">

                <div class="flex justify-end items-end ">
                    <mat-form-field class=" w-1/2 md:w-1/6">
                        <mat-label class="max-sm:text-md">Amount to pay</mat-label>
                        <input matInput type="number" [value]="accountInArrears ? payOwnAmount : '0'" (keyup)="ownAmount($event)">
                    </mat-form-field>
                </div>

                <div class="flex justify-end items-end ">
                    <button *ngIf="!loading" class="text-lg font-bold bg-accent self-start w-1/2 md:w-1/6" mat-flat-button [color]="'accent'" (click)="payNow()" [disabled]="disableButton">
                        Pay now
                    </button>
                    <button *ngIf="loading" class=" w-1/2 md:w-1/6" mat-flat-button [color]="'accent'" disabled>
                        <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
                    </button>
                </div>

            </fuse-card>
        </div>
    </div>
</section>